import fetchJsonp from 'fetch-jsonp';

const getWeather = function(fn, options = { time: 0}) {

  const url = `https://api.darksky.net/forecast/0059211d748f35bbf76d39736cc785de/40.7139891,-74.050506${options.time ? ',' + options.time : ''}`;

  fetchJsonp(url)
    .then(response => {
      return response.json();
    }).then(json => {
      fn(json);
    }).catch(function(err) {
      console.log('parsing failed', err);
    });

};

export default getWeather;



// WEBPACK FOOTER //
// ./src/requests/getWeather.js